/**
 * @function asset
 * @since 1.0.0
 */
export function asset(file) {
    return '/' + file;
}
